<template>
    <div class="sc-scenario">
        <pui-form-group
            :label="$t('results.kpiAnalysis.selector.selectScenario')"
            :cta-label="$t('form.clear')"
            :has-cta="true"
            :cta-callback="clearScenario"
            :show-required-label="true"
            :has-label-padding="false"
            label-for="selectScenario"
        >
            <benchmarking-type-ahead
                :ref="REF_CONSTANTS.TYPEAHEAD"
                :value="selectedScenario"
                :placeholder="$t('results.kpiAnalysis.selector.selectPlaceholder')"
                :request-promise-generator="scenariosRequestPromiseGenerator"
                @input="onSelectedScenarioChange"
            />
        </pui-form-group>
    </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ManagedAbortControllers } from '@/mixins/managed-abort-controllers';
import { EngineRunServiceProxy, IScenarioRunDto } from '@/service-proxies/service-proxies.g';
import { ScenarioCompareScenarioSelectOption } from '@/models/results/scenario-compare';
import BenchmarkingTypeAhead from '@/components/inputs/benchmarking-type-ahead/benchmarking-type-ahead.vue';
import { SCENARIO_STATUS } from '@/config/status';

const REF_CONSTANTS = {
    TYPEAHEAD: 'typeahead',
} as const;

@Component({
    components: {BenchmarkingTypeAhead}
})
export default class ScenarioCompareLinkedScenarioSelector extends mixins(ManagedAbortControllers) {
    private readonly engineRunService = new EngineRunServiceProxy();
    private readonly REF_CONSTANTS = REF_CONSTANTS;

    $refs!: {
        [REF_CONSTANTS.TYPEAHEAD]?: BenchmarkingTypeAhead,
    };

    private get selectedScenario(): ScenarioCompareScenarioSelectOption | null {
        const selectedScenario: IScenarioRunDto = this.$store.getters['results/getSelectedScenario'];

        return selectedScenario ? {
            label: selectedScenario.name ?? '-',
            value: selectedScenario.id,
            extraData: selectedScenario,
        } : null;
    }

    mounted(): void {
        this.onSelectedScenarioChange(this.selectedScenario ?? undefined);
    }

    private async scenariosRequestPromiseGenerator(query: string, signal: AbortSignal): Promise<ScenarioCompareScenarioSelectOption[]> {
        const statuses = [
            Number(SCENARIO_STATUS.ENGINE_RUN_COMPLETED),
            Number(SCENARIO_STATUS.ENGINE_RUN_FAILED)
        ];

        const response = await this.engineRunService.list7(undefined, undefined, statuses, 1, 20, query, undefined, signal);
        return response.result.items?.map(e => ({
            label: e.name ?? '',
            value: e.id,
            extraData: e,
        })) ?? [];
    }

    private onSelectedScenarioChange(newSelectedScenario: ScenarioCompareScenarioSelectOption | undefined): void {
        this.$store.commit('results/setSelectedScenario', newSelectedScenario?.extraData);

        this.clearAppliedFilters();
        this.$emit('change:scenario', newSelectedScenario);
    }

    private clearAppliedFilters(): void {
        this.$store.dispatch('results/scenarioCompare/clearAppliedFilters');
    }

    private clearScenario(): void {
        this.$refs.typeahead?.clearInput();
    }
}
</script>
